import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { withTheme, LightThemeColors, Colors } from '../../Themes';

import { ORIENTATION_TYPES, BORDER_TYPES } from './UsageIndicator.Enums';
import styles from './UsageIndicator.Styles';

class UsageIndicator extends Component {
  constructor(props) {
    super(props);
  }

  getFillViewStyle = (style, type, borderType, borderRadius, fillColor, width) => {
    const styleArr = [];

    styleArr.push(style);
    styleArr.push(this._getBorderStyle(type, borderType, borderRadius));
    styleArr.push({ backgroundColor: fillColor });
    styleArr.push(this._getViewWidth(type, width));

    if (type === ORIENTATION_TYPES.VERTICAL) {
      styleArr.push({ height: '100%', justifyContent: 'flex-end' });
    } else if (type === ORIENTATION_TYPES.HORIZONTAL) {
      styleArr.push({ width: '100%' });
    }

    return StyleSheet.flatten(styleArr);
  };

  getBarViewStyle = (
    type,
    borderType,
    borderRadius,
    indicatorColor,
    width,
    indicatorValue = 0,
    offset = 0,
  ) => {
    const styleArr = [styles.barStyle];
    const toIndicatorValue = Number.isNaN(offset + indicatorValue) ? 0 : offset + indicatorValue;
    styleArr.push(this._getBorderStyle(type, borderType, borderRadius));
    styleArr.push({ backgroundColor: indicatorColor });
    styleArr.push(this._getViewWidth(type, width));

    const value = `${toIndicatorValue}%`;

    if (type === ORIENTATION_TYPES.VERTICAL) {
      styleArr.push({ height: value });
    } else if (type === ORIENTATION_TYPES.HORIZONTAL) {
      styleArr.push({ width: value });
    }

    return StyleSheet.flatten(styleArr);
  };

  _getBorderStyle = (type, borderType, borderRadius) => {
    switch (borderType) {
      case BORDER_TYPES.ALL:
        return { borderRadius: borderRadius };
      case BORDER_TYPES.START:
        if (type === ORIENTATION_TYPES.VERTICAL) {
          return {
            borderBottomLeftRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
          };
        } else {
          return {
            borderBottomLeftRadius: borderRadius,
            borderTopLeftRadius: borderRadius,
          };
        }
      case BORDER_TYPES.END:
        if (type === ORIENTATION_TYPES.VERTICAL) {
          return {
            borderTopLeftRadius: borderRadius,
            borderTopRightRadius: borderRadius,
          };
        } else {
          return {
            borderBottomRightRadius: borderRadius,
            borderTopRightRadius: borderRadius,
          };
        }
      default:
        return { borderRadius: 0 };
    }
  };

  _getViewWidth = (type, width) => {
    if (type === ORIENTATION_TYPES.VERTICAL) {
      return { width: width };
    } else if (type === ORIENTATION_TYPES.HORIZONTAL) {
      return { height: width };
    }
  };

  renderUsageIndicators = () => {
    const {
      width,
      type,
      borderRadius,
      borderType,
      values,
      colors,
      indicatorAccessabilityLabel,
      theme,
    } = this.props;
    const usageIndicators = _map(values, (indicatorValue, i) => {
      const { value } = indicatorValue;
      let offset = 0;
      if (i > 0) {
        offset = values[i - 1].value;
      }
      return (
        <View
          style={this.getBarViewStyle(
            type,
            borderType,
            borderRadius,
            colors[i] || theme.colors.activeColorThree,
            width,
            value,
            offset,
          )}
          accessibilityLabel={
            indicatorAccessabilityLabel ?? FoundationTestKeys.usageChartUsageIndicator
          }
          testID={indicatorAccessabilityLabel ?? FoundationTestKeys.usageChartUsageIndicator}
        />
      );
    });
    return usageIndicators.reverse();
  };

  render() {
    const { style, width, type, borderRadius, borderType, fillColor, fillAccessabilityLabel } =
      this.props;

    const fillStyle = this.getFillViewStyle(
      style,
      type,
      borderType,
      borderRadius,
      fillColor,
      width,
    );

    return (
      <View
        style={fillStyle}
        accessibilityLabel={
          fillAccessabilityLabel ?? FoundationTestKeys.usageChartUsageIndicatorView
        }
        testID={fillAccessabilityLabel ?? FoundationTestKeys.usageChartUsageIndicatorView}
      >
        {this.renderUsageIndicators()}
      </View>
    );
  }
}

UsageIndicator.defaultProps = {
  style: {},
  width: 4,
  type: ORIENTATION_TYPES.HORIZONTAL,
  borderRadius: 2.5,
  borderType: BORDER_TYPES.ALL,
  values: [],
  fillColor: Colors.transparent,
  theme: LightThemeColors,
  colors: [],
};

UsageIndicator.propTypes = {
  style: ViewPropTypes.style,
  width: PropTypes.number,
  type: PropTypes.string,
  borderRadius: PropTypes.number,
  borderType: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
    }),
  ),
  colors: PropTypes.arrayOf(PropTypes.string),
  fillColor: PropTypes.string,
  fillAccessabilityLabel: PropTypes.string,
  indicatorAccessabilityLabel: PropTypes.string,
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export { UsageIndicator };
export default withTheme(UsageIndicator);
